export default __webpack_public_path__ + "static/media/Days_18.6ac36492.png";